import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import '../styles/BackToTop.css';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={handleClick}
      className={`back-to-top ${visible ? 'is-visible' : ''}`}
      data-testid="back-to-top-btn"
    >
      <ArrowUp size={18} strokeWidth={2.25} />
      <span className="back-to-top-label">Top</span>
    </button>
  );
};

export default BackToTop;
